import { Card } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoadingProduct } from "../../../components";
import { AddDataSlider } from "../../../config/Redux/action";
import { ActionProduct } from "../../../config/Redux/actionTypes";

const SliderForm = () => {
    const intialInput = {
        image_url: '',
        title:'',
        subtitle:''
    };
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [input, setInput] = useState(intialInput);
    let slider = useSelector((state) => state.product);

    
  useEffect(() => {
    if (slider.successCreate === true) {
      navigate('/dashboard/slider');
      dispatch({ type: ActionProduct.SUCCESS_CREATE, value: false });
    }
  }, [dispatch, navigate, slider.successCreate]);

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setInput({ ...input, [name]: value });  
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(AddDataSlider(input));
        setInput(intialInput)
    }
    return (
      <div className='form-product site-card-border-less-wrapper'>
        <Card
          className='card'
          title={<h1>Form Shirt</h1>}
          bordered={true}
          style={{ width: '100%', height: '80vh' }}
        >
          <div>
            <form onSubmit={handleSubmit}>
              <div>
                <label>cover</label>
                <input
                  required
                  type='text'
                  name='image_url'
                  value={input.image_url}
                  onChange={handleOnChange}
                />
              </div>
              <div>
                <label>Title</label>
                <input
                  required
                  type='text'
                  name='title'
                  value={input.title}
                  onChange={handleOnChange}
                />
              </div>
              <div>
                <label>Sub Title</label>
                <input
                  required
                  type='text'
                  name='subtitle'
                  value={input.subtitle}
                  onChange={handleOnChange}
                />
              </div>
              {slider.isLoading ? (
                <LoadingProduct />
              ) : (
                <input
                  style={{ marginTop: '30px' }}
                  type='submit'
                  value={'Save'}
                />
              )}
            </form>
          </div>
        </Card>
      </div>
    );
}

export default SliderForm